import React from 'react';
import { Download } from 'lucide-react';
import { SEO, buildBreadcrumbLd } from '../components/SEO';

const BREADCRUMB = buildBreadcrumbLd([
  { name: 'Əsas səhifə', path: '/' },
  { name: 'Haqqımızda', path: '/haqqimizda/biz-kimik' },
  { name: 'Maliyyə hesabatları', path: '/haqqimizda/hesabatlar' },
]);

const reports = [
  {
    year: 2025,
    title: 'İllik hesabat',
    url: '/reports/idk-hesabat-2025.pdf',
    sizeMB: 4.3
  },
  {
    year: 2024,
    title: 'İllik hesabat',
    url: '/reports/idk-hesabat-2024.pdf',
    sizeMB: 0.9
  },
  {
    year: 2023,
    title: 'İllik hesabat',
    url: '/reports/idk-hesabat-2023.pdf',
    sizeMB: 1.4
  },
  {
    year: 2022,
    title: 'İllik hesabat',
    url: '/reports/idk-hesabat-2022.pdf',
    sizeMB: 0.8
  }
];

const formatSize = (mb) => {
  if (mb < 1) return `${Math.round(mb * 1024)} KB`;
  return `${mb.toFixed(1)} MB`;
};

export const ReportsPage = () => {
  return (
    <div className="bg-white">
      <SEO
        title="Maliyyə hesabatları | İDK BOKT"
        description="İDK BOKT-nin illik maliyyə hesabatları və şəffaflıq sənədləri. İllər üzrə PDF formatında yükləyin."
        path="/haqqimizda/hesabatlar"
        jsonLd={BREADCRUMB}
      />
      {/* Hero - eyni gradient stil */}
      <section className="bg-gradient-to-b from-blue-50 to-white pt-12 pb-8">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 font-serif-display">Hesabatlar</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            İnkişafa Dəstək Kreditləri BOKT-nin fəaliyyət dövrü üzrə hazırlanmış rəsmi illik maliyyə hesabatları.
          </p>
        </div>
      </section>

      {/* Reports list */}
      <section className="pt-4 pb-28">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
          <div className="divide-y divide-gray-200">
            {reports.map((report) => (
              <a
                key={report.year}
                href={report.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-6 sm:gap-10 py-7 hover:px-3 transition-all duration-300"
                data-testid={`report-${report.year}`}
              >
                <div className="flex-shrink-0 w-24 sm:w-32">
                  <span className="block text-4xl sm:text-5xl font-light text-gray-900 group-hover:text-blue-700 transition-colors tracking-tight">
                    {report.year}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-1">
                    {report.title}
                  </h3>
                  <p className="text-sm text-gray-500" data-testid={`report-meta-${report.year}`}>
                    PDF • {formatSize(report.sizeMB)}
                  </p>
                </div>
                <div className="flex-shrink-0 inline-flex items-center gap-2 px-4 sm:px-5 py-2.5 rounded-lg bg-blue-700 text-white text-sm font-medium group-hover:bg-blue-800 transition-colors shadow-sm">
                  <Download className="h-4 w-4" />
                  <span>Yüklə</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
